/**
 * Eventos do chat interno que atravessam a árvore de componentes.
 *
 * Constante, e não string solta nos dois lados: o emissor mora no helper do
 * cabo e o ouvinte num componente global. Errar uma letra num dos dois é um
 * evento que nunca chega, e sem erro nenhum no console.
 */
export const AVISO_DE_MENSAGEM = 'internalChat.avisoDeMensagem';
